import { useWatch, useFormContext } from "react-hook-form";
import { FontStyles } from "../../constants";
import FormSubSection from "../../CommonFields/FormSubSection";
import { FormColorPicker, FormSelect, FormRangeSlider, FormInputWithUnit } from "../../../../components/FormFields";
import styles from "../Shared/CommonFields.module.css";

const VolumeDesignSavingsSummaryCard = () => {
    const { control } = useFormContext();
    const status = useWatch({ control, name: "savings_summary.status" });

    if (!status) {
        return null;
    }

    return (
        <div id="savings-summary">
            <FormSubSection rowLabel={"Savings Summary"} hideSeparator>
                <FormColorPicker name="bundles_design.savings_summary_text_color" label="Text Color" />
                <FormColorPicker name="bundles_design.savings_summary_background_color" label="Background Color" />
                <FormInputWithUnit
                    name="bundles_design.savings_summary_font_size"
                    min={0}
                    label="Font Size"
                    placeholder="Font size"
                    unitSuffix="px"
                />
                <FormSelect
                    name="bundles_design.savings_summary_font_style"
                    label="Font Style"
                    options={FontStyles}
                    placeholder="Font style"
                />
                <FormRangeSlider
                    name="bundles_design.savings_summary_border_radius"
                    min={0}
                    max={100}
                    label="Border Radius"
                    suffixTemplate={(val) => `${val}px`}
                    wrapperClassName={styles.rangeSliderOverride}
                />
            </FormSubSection>
        </div>
    );
};

export default VolumeDesignSavingsSummaryCard;
